import { Group, Stack, Text, Flex } from "@mantine/core"
import { PersonProfilePictureAvatar } from "../../../../-components/person-profile-picture-avatar"
import dayjs from "dayjs"
import { useElementSize } from "@mantine/hooks"
import { ellipsify } from "../../../../../../utils/ellipsify"
import { SimpleUserWithPerson } from "@/orval/gen/model"

interface Props {
  author: SimpleUserWithPerson
  authorSubtext?: string
  timeStamp: string
  rightSection?: React.ReactNode
}

export function PostHeader({
  author,
  authorSubtext,
  timeStamp,
  rightSection,
}: Props) {
  const { ref, width } = useElementSize()

  return (
    <Group ref={ref} w="100%" align="center" wrap="nowrap">
      {author.person?.personId && author.userName ? (
        <PersonProfilePictureAvatar
          personId={author.person.personId}
          name={author.userName}
        />
      ) : null}
      <Stack gap={0}>
        <Text>{author.person?.name}</Text>
        {authorSubtext ? (
          <Text size="sm" c="dimmed">
            {authorSubtext}
          </Text>
        ) : null}
      </Stack>
      <Flex flex={1} />
      <Flex justify="flex-end" flex="1 0 70px" w="0" wrap="wrap">
        <Text
          style={{ ...ellipsify, whiteSpace: undefined, textAlign: "right" }}
          size="sm"
          c="dimmed"
        >
          {dayjs(timeStamp).format(width < 400 ? "LT L" : "LT ddd L")}
        </Text>
      </Flex>
      {rightSection ?? null}
    </Group>
  )
}
